import { Tab, Tabs } from '@material-ui/core'
import { useAutorun, useReactionNow, useRouterContext } from '@speedlo/hooks'
import {
  useAsObservableSource,
  useLocalStore,
  useObserver,
} from 'mobx-react-lite'
import React from 'react'
import { paths, SegmentKey } from 'shopify-payment-core'

import { useFirebase } from '../atoms/Firebase'
import { useRoot } from '../atoms/RootProvider'
import { logError } from '../helpers/logger'

interface IProps {
  selected: Maybe<ID>
  onNavigate(accountId: ID): void
  segmentKey: SegmentKey
}

export const SwitchBarClient: React.FC<IProps> = ({
  selected,
  onNavigate,
  segmentKey,
}) => {
  const { ref } = useFirebase()
  const { auth } = useRoot()
  const { history } = useRouterContext()

  const source = useAsObservableSource({ selected, segmentKey })
  const state = useLocalStore(() => ({
    get available() {
      return auth.getSegmentAccess(source.segmentKey as SegmentKey)
    },
    shopNames: new Map<ID, string>(),
  }))

  useAutorun(() => {
    if (
      source.selected === null &&
      auth.isAuthenticated &&
      state.available.length > 0
    ) {
      history.replace(`/${state.available[0]}`)
    }
  })

  useReactionNow(
    () => state.available,
    accountIds => {
      accountIds.forEach(id => {
        if (state.shopNames.has(id)) {
          return
        }
        ref(paths.gopay.getAccount(id))
          .child('shopName')
          .once('value')
          .then(snapshot => {
            return snapshot.exists() ? (snapshot.val() as string) : null
          })
          .catch(err => {
            logError(err)
            return
          })
          .then(name => {
            state.shopNames.set(id, name || `???`)
          })
      })
    },
  )

  return useObserver(() => (
    <Tabs
      variant="scrollable"
      value={source.selected}
      onChange={(ev, value) => {
        onNavigate(value)
      }}
    >
      {state.available.map(id => (
        <Tab key={id} label={state.shopNames.get(id) || '...'} value={id} />
      ))}
    </Tabs>
  ))
}
